// Toast bus: any module can raise a toast; <Toaster/> (mounted once) renders them.
const listeners = new Set();
let seq = 0;

/**
 * Show a short message in the corner.
 * @param {string} message what happened, in the user's words
 * @param {{ kind?: "info"|"success"|"error", ms?: number }} [opts]
 * @returns {number} the toast's id
 */
export function toast(message, { kind = "info", ms = 5000 } = {}) {
  const t = { id: ++seq, message: String(message || ""), kind, ms };
  listeners.forEach((fn) => fn(t));
  return t.id;
}

/** Subscribe to new toasts; returns the unsubscribe function. */
export function onToast(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
